const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/pages/new.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { LOCALE_MAP } from "@/lib/locale";
export const Route = createFileRoute("/dashboard/admin/pages/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>) => ({
    groupId: search.groupId as string || undefined,
    locale: search.locale as string || undefined
  })
});